import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import {
  ImageBackground,
  SafeAreaView,
  StatusBar,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { LinearGradient } from '../../ui/components/LinearGradient';
import { StatusBarComponent } from '../../ui/components/StatusBar';
import { defaultScale, scaleImageAspectRatio } from '../../utils/scaling';

interface IProps {
  t: (key: string) => string;
  targetStatus: boolean | null;
  headerImage: any;
  imageStyle: ViewStyle;
  goToPreviousStep: () => void;
  hasGradient: boolean;
}

export const WeightTargetImageHeaderComponent: FunctionComponent<IProps> = ({
  goToPreviousStep,
  headerImage,
  imageStyle,
  children,
  hasGradient = false,
}) => {
  return (
    <View>
      <StatusBarComponent barStyle='light-content' />
      <ImageBackground
        source={headerImage}
        resizeMode='cover'
        style={[styles.imageContainer, imageStyle]}
      >
        <>
         <SafeAreaView style={{flex:0}}/>
          {hasGradient && (
            <View style={StyleSheet.absoluteFill}>
              <LinearGradient
                colors={['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.77)']}
                style={{ flex: 1 }}
              />
            </View>
          )}

        <TouchableOpacity onPress={goToPreviousStep} style={[styles.closeIconContainerStyle]}>
          <Icon name='md-close' color={Theme.GREY_LIGHT} size={defaultScale(30)} />
        </TouchableOpacity>
          {children}
        </>
      </ImageBackground>
    </View>
  );
};

const styles = StyleSheet.create({
  imageContainer: {
    width: '100%',
    aspectRatio: scaleImageAspectRatio(1.4),
  },
  iconContainerStyle: {
    marginHorizontal: defaultScale(15),
    paddingTop: defaultScale(15),
  },
  closeIconContainerStyle: {
    alignSelf: 'flex-end',
    marginHorizontal: defaultScale(15),
    zIndex: 10,
    marginTop: defaultScale(15),
  },
});

export const WeightTargetImageHeader = translate(['weightTarget'])(
  WeightTargetImageHeaderComponent,
);
